module.exports = __webpack_public_path__ + "static/img/banner01.5dec7e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/banner01.png
// module id = 6CLV
// module chunks = 1